import React from "react";
import {
  Grid,
  Typography,
  List,
  Divider,
  ListItemButton,
  ListItemText,
  Paper,
  Button
} from "@mui/material";
import request from "../../../utilities/requests";

const HelpTopic = ({ topicId, goBack }) => {
  const [data, setData] = React.useState({});

  React.useEffect(() => {
    const getData = async () => {
      const result = await request(`help?topicId=${topicId}`);
      if (result.success) {
        setData(result.data);
      }
    };
    getData();
  }, [topicId]);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
      spacing={3}
    >
      <Grid item style={{width: '100%', display: 'flex'}}>
       <Button style={{fontWeight: 'bold', padding: 20}} onClick={goBack}>{"back to help"}</Button>
      </Grid>
      {data?.videoUrl ? (
        <Grid item>
          <video width="320" height="240" controls>
            <source src={data?.videoUrl} type="video/mp4" />
          </video>
        </Grid>
      ) : (
        <></>
      )}
      <Grid item>
        <div dangerouslySetInnerHTML={{ __html: data?.html }} />
      </Grid>
    </Grid>
  );
};

export default HelpTopic;
